import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EmployeeService } from 'src/app/POS/POSServices/Employees/employee.service';
import { CommonFunctionService } from 'src/app/services/Common/common-function.service';

const _clone = (d) => JSON.parse(JSON.stringify(d));
@Component({
  selector: 'app-ac-header',
  templateUrl: './ac-header.component.html',
  styleUrls: ['./ac-header.component.scss']
})
export class AcHeaderComponent implements OnInit {

  rows = [];
  MerchantKeyId: any;
  resellerno: any;
  posvalue = 0;
  username: any;
  isShown: boolean = false;
  navCollapsed = true; // for horizontal layout
  menuItems = []; // for horizontal layout
  submenu = true; // for horizontal layout
  submenupos = true;
  reportmenu = true;
  settingsmenu = true;
  profilemenu = true;

  constructor(private commonfunction: CommonFunctionService, private router: Router, private service: EmployeeService) {
    this.username = this.commonfunction.getUserName();
    this.Posoption();
  }
  get headerTitle() {
    if (this.router.url.includes('/accounting/vouchers')) {
      return 'Manage Invoices';
    }
    else if (this.router.url.includes('/accounting/voucher/add')) {
      return 'Add Invoice';
    }
    
    else if (this.router.url.includes('/accounting/voucher/edit')) {
      return 'Edit Invoice';
    }
    else if (this.router.url.includes('/accounting/voucher/view')) {
      return 'View Invoice';
    }
    else if (this.router.url.includes('/accounting/item/new')) {
      return 'New Item';
    }
    else if (this.router.url.includes('/accounting/item/edit')) {
      return 'Edit Item';
    }
    else if (this.router.url.includes('/accounting/supplier/add')) {
      return 'Add Contact';
    }
    else if (this.router.url.includes('/accounting/supplier/edit')) {
      return 'Edit Contact';
    }
    else if (this.router.url.includes('/accounting/contact/view')) {
      return 'Contact Detail';
    }
    else if (this.router.url.includes('/accounting/items')) {
      return 'Manage Items';
    }
    else if (this.router.url.includes('/accounting/item/view')) {
      return 'Item Detail';
    }
    else if (this.router.url.includes('/accounting/suppliers')) {
      return 'Manage Contacts';
    }
    else if (this.router.url.includes('/accounting/purchase-orders')) {
      return 'Manage Purchase Orders';
    }
    else if (this.router.url.includes('/accounting/purchase-order/add')) {
      return 'Add Purchase Order';
    }
    else if (this.router.url.includes('/accounting/purchase-order/view')) {
      return 'Purchase Order Detail';
    }
    else if (this.router.url.includes('/accounting/purchase-order/edit')) {
      return 'Edit Purchase Order';
    }
    else if (this.router.url.includes('/accounting/orders')) {
      return 'Manage Orders';
    }
    else if (this.router.url.includes('/accounting/ewaybill')) {
      return 'Manage EwayBill';
    }
    else if (this.router.url.includes('/accounting/pnl')) {
      return 'P&L Statement';
    }
    else if (this.router.url.includes('/accounting/order/add')) {
      return 'Add Order';
    }
    else if (this.router.url.includes('/accounting/order/view')) {
      return 'Order Detail';
    } 
    else if (this.router.url.includes('/accounting/order/edit')) {
      return 'Edit Order';
    }
    else if (this.router.url.includes('/accounting/purchase-invoices')) {
      return 'Manage Purchase Invoice';
    }
    else if (this.router.url.includes('/accounting/purchase-invoice/add')) {
      return 'Add Purchase Invoice';
    }
    else if (this.router.url.includes('/accounting/purchase-invoice/view')) {
      return 'Purchase Invoice Detail';
    }
    else if (this.router.url.includes('/accounting/purchase-invoice/edit')) {
      return 'Edit Purchase Invoice';
    }
    else if (this.router.url.includes('/accounting/expense-voucher')) {
      return 'Expense Voucher';
    }
    else if (this.router.url.includes('/accounting/balance-sheet')) {
      return 'Balance Sheet';
    } 
    else {
      return 'Dashboard';
    }
  }
  ngOnInit() {
  }




  Posoption() {
    this.MerchantKeyId = this.commonfunction.getUserMerchantData().MerchantKeyId;
    this.resellerno = this.commonfunction.getUserMerchantData().ResellerId;
    this.service.getMerchantServicesAndFees(this.MerchantKeyId, this.resellerno).subscribe(result => {
      if (result != null) {

        this.rows = _clone(result);;

        this.rows.forEach(element => {
          if (element.ServiceCode == "Pos" && element.Status == 1) {
            this.posvalue = 1;
          }
        });
        if (this.posvalue == 1) {
        }
        else {
          this.router.navigate(["/home"]);
        }

      }



    });

  }

}
